import { Mail, MapPin } from 'lucide-react';
import { CONTACT, LOANS, BANKS, INSURANCE } from '../data';

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0D111A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-4">
                <div className="flex items-center gap-2.5">
                    <span className="w-8 h-8 rounded-md bg-emerald-500 flex items-center justify-center font-display font-black text-[#04110c] text-sm">
                        PA
                    </span>
                    <span className="font-display font-bold tracking-tight">
                        PREM <span className="text-emerald-400">ASSOCIATES</span>
                    </span>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
                    Your capital concierge. Authorised DSA connecting borrowers to India's
                    leading banks and NBFCs.
                </p>
            </div>
            <div className="md:col-span-3">
                <h4 className="font-mono-x text-[11px] uppercase tracking-[0.22em] text-slate-500 mb-4">
                    Loan Suite
                </h4>
                <ul className="space-y-2.5">
                    {LOANS.map((l) => (
                        <li key={l.id}>
                            <a
                                href="#apply"
                                className="text-sm text-slate-400 hover:text-emerald-300 transition-colors"
                            >
                                {l.title}
                            </a>
                        </li>
                    ))}
                </ul>
                <h4 className="font-mono-x text-[11px] uppercase tracking-[0.22em] text-slate-500 mt-7 mb-4">
                    Insurance
                </h4>
                <ul className="space-y-2.5" data-testid="footer-insurance-links">
                    {INSURANCE.map((ins) => (
                        <li key={ins.id}>
                            <a
                                href="#insurance"
                                className="text-sm text-slate-400 hover:text-emerald-300 transition-colors"
                            >
                                {ins.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="md:col-span-2">
                <h4 className="font-mono-x text-[11px] uppercase tracking-[0.22em] text-slate-500 mb-4">
                    Partners
                </h4>
                <ul className="space-y-2.5">
                    {BANKS.map((b) => (
                        <li key={b.code} className="text-sm text-slate-400">
                            {b.name}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="md:col-span-3">
                <h4 className="font-mono-x text-[11px] uppercase tracking-[0.22em] text-slate-500 mb-4">
                    Contact
                </h4>
                <ul className="space-y-3 text-sm text-slate-400">
                    <li className="flex items-start gap-2.5">
                        <Mail className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                        <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-emerald-300 transition-colors break-all">
                            {CONTACT.email}
                        </a>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <MapPin className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                        <span data-testid="footer-address">{CONTACT.address}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-white/5">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3">
                <p className="text-xs text-slate-600">
                    © {new Date().getFullYear()} Prem Associates · {CONTACT.domain}
                </p>
                <p className="text-xs text-slate-600 max-w-xl">
                    Prem Associates acts as a Direct Selling Agent (DSA). Loans are sanctioned
                    and disbursed solely at the discretion of partner banks/NBFCs. Rates shown
                    are indicative.
                </p>
            </div>
        </div>
    </footer>
);
